import React from "react";
import "./footer.css";
export default function Footer() {
  return (
    <>
      <footer>
        <div className="footer-wrap">
          <div className="footer-content">
            <div className="footer-1">
              <h3>ABOUT FARM HOUSE</h3>
              <p> Who We Are Blog Work </p>
              <p>Investor Relations</p>
              <p>Contact Us</p>
              <p>Report Fraud</p>
            </div>
            <div className="footer-1">
              <h3>Privacy</h3>
              <p> Security</p>
              <p>Terms</p>
              <p>Contact Us</p>
              <p>Sitemap</p>
            </div>

            <div className="footer-1">
              <h3>Privacy</h3>
              <p> Security</p>
              <p>Terms</p>

              <p>Sitemap</p>
            </div>
          </div>
          <div className="bottom">
            <p>© Suraj Sivakumar Ltd. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
}
